module.exports = __webpack_public_path__ + "media/images/result_sets/circles/2n3n4r8r-c3cfdb9d3c9489c8cb84441dba641c45.svg";